import { OrderFormCategoryDTO } from 'support/types/dtos';

import { Categories } from './components/Categories/Categories';
import { Search } from './components/Search/Search';

type OrderFormSidebarProps = {
  withoutMatches?: boolean;
  categories: Array<OrderFormCategoryDTO>;
};

export const OrderFormSidebar = ({ categories, withoutMatches }: OrderFormSidebarProps) => {
  return (
    <div className="flex-col gap-6">
      <Search />
      <Categories withoutMatches={withoutMatches} categories={categories} />
    </div>
  );
};
